export default function ProcessRecoveryFunctionDirective() {
  return {
    template: require('./process-recovery-function.html'),
    scope: {
      function: '=',
      isEditable: '=',
    },
    controller: 'ProcessRecoveryFunctionController',
    controllerAs: 'processRecoveryFunctionVM',
    bindToController: true,
    replace: true,
  };
}
